import { useSelector } from 'react-redux';

// Design system
import { Message } from 'jl-design-system/components/message/Message';

// Config
import klarnaConnectMessageState from './KlarnaConnectMessage.state';

// Components
import Container from '../container';

const KlarnaConnectMessage = () => {
  const { showMessage } = useSelector(klarnaConnectMessageState);

  return showMessage && (
    <Container marginBottom="2">
      <Message
        body="Please consider using an alternative payment method."
        dataId="unable-connect-klarna"
        scrollToMessageOnMount
        title="Sorry, we've been unable to connect to Klarna"
        type="error"
      />
    </Container>
  );
};

export default KlarnaConnectMessage;
